import {Component, Inject, Prop, Vue} from "vue-property-decorator";
import {Checkbox} from "~/components/checkbox";
import {ResourcesPicker} from "~/modules/settings/resources-picker";
import {
  addResourcesToGroup,
  getAllResourcesOfGroup,
  getMapOverlays,
  getClientGroups, getClientMaps, getNamespacedResourcesCompositionForClient,
  removeResourcefromGroup,
  saveNamespacedResourcesCompositionForClient
} from "~/modules/settings/services";
import {ResourceComposition} from "~/modules/settings/resources-composition";
import {Getter} from "vuex-class";
import {AppSettings} from "~/lib/app-settings";

const MAP_OVERLAY_SERIALIZED_TYPE = 5;

const config = {
  type: "map_overlay",
  title: "Cartes (overlay)",
  noResourceText: "Aucune carte",
  addResourceText: "Attacher une carte",
  clientResourceService: async clientUUid => getClientMaps(clientUUid),
};

@Component
export class MapOverlays extends Vue {

  @Getter currentUser;
  @Inject() appSettings: AppSettings;

  // Do not show packs
  protected groups = [];
  protected mapsByGroupUUID = {};
  protected showResourcesPicker = false;
  protected ready = false;
  protected selectedGroup = null;
  protected mapOverlaysComposition: ResourceComposition = null;

  async created() {

    this.groups = (await getClientGroups(this.appSettings.clientUUID)).filter(grp => ! grp.isCrossClient);

    for( const group of this.groups){
        const overlays = await getMapOverlays(group.uuid);
        Vue.set(this.mapsByGroupUUID, group.uuid, overlays || []);
    }

    // We load existing mapOverlays config (which is a list of configs, we take the last)
    const configs = await getNamespacedResourcesCompositionForClient(this.appSettings.clientUUID, "maps-overlays");
    this.setComposition(configs);

    this.ready = true;
  }

  setComposition(config) {
    this.mapOverlaysComposition = config?.length === 0 ? new ResourceComposition("maps-overlay-config") : ResourceComposition.fromPayload(config[config.length - 1]);
  }

  isGroupMapOverlay(group) {
    return this.mapOverlaysComposition.groups.some(grp => grp.uuid === group.uuid);
  }

  renderGroupsList() {
    if (!this.ready) return <p>Chargement</p>;
    return this.groups
      .filter(group => !group.isCrossClient) // Exclude packs from the listing
      .map(group => {
        return <MapGroupItem
          group={group}
          isMapOverlay={this.isGroupMapOverlay(group)}
          maps={this.mapsByGroupUUID[group.uuid]}
          onToggle={this.toggleGroup}
          onLoadMapPicker={group => {
            this.selectedGroup = group;
            this.showResourcesPicker = true
          }}
          onRemoveMap={this.removeMapFromGroup}
        />;
      });
  }

  /**
   * Replace the state of mapsByGroupUUI[selectedGroup] with a new map selection
   * The whole state is sent to the server and is persisted, replacing the previous state
   */
  async addToGroup(selection = []) {

    // selection from resourcePicker is already [ ...prevMap state, ...newMapState]
    Vue.set(this.mapsByGroupUUID, this.selectedGroup.uuid, selection);

    console.log(selection);

    await addResourcesToGroup(
      this.selectedGroup.uuid,
      "map_overlay",
      selection.map(resource => resource.uuid)
    );

    this.selectedGroup = null;
    this.showResourcesPicker = false;
  }

  /**
   * Remove one map by cherry-picking it from the group state
   * Only that map is removed, server-side (no state replacement)
   */
  async removeMapFromGroup(group, map) {
    this.mapsByGroupUUID[group.uuid] = this.mapsByGroupUUID[group.uuid].filter(item => item.uuid !== map.uuid);
    await removeResourcefromGroup(group.uuid, "map_overlay", map.uuid);
  }

  async toggleGroup(group) {
    this.mapOverlaysComposition.toggleGroup(group);
    const configs = await saveNamespacedResourcesCompositionForClient(this.appSettings.clientUUID, "maps-overlays", [this.mapOverlaysComposition.toJson()]);
    this.setComposition(configs);
  }

  render() {
    return (
      <div>
        <h2 class="page-subtitle">Surcouches de cartes</h2>
        {this.renderGroupsList()}
        {this.showResourcesPicker && <ResourcesPicker
          preSelect={this.mapsByGroupUUID[this.selectedGroup.uuid]}
          nameParser={map => map.name}
          service={config.clientResourceService}
          onSelect={this.addToGroup}
          onCancel={() => (this.showResourcesPicker = false)}
        />}
      </div>
    );
  }
}

@Component
class MapGroupItem extends Vue {

  @Prop({type: Object, required: true}) group;
  @Prop({type: Array, required: true}) maps;
  @Prop({type: Boolean, required: true}) isMapOverlay;

  protected attach = false;

  loadMapPicker() {
    this.$emit("loadMapPicker", this.group);
  }

  attachToMapOverlays() {
    this.$emit("toggle", this.group);
  }

  renderMapsList() {
    if (!this.maps.length) return <p>Aucune carte attachée</p>;
    return this.maps.map(item => {
      return (
        <div class="mo-group-map">
          <span>{item.name}</span>
          <button class="button is-small" onClick={() => this.$emit("removeMap", this.group, item)}>Detacher</button>
        </div>
      );
    })
  }

  render() {
    return (
      <div class="mo-group-item">
        <h4 class="mo-group-label">{this.group.label}</h4>
        <div class="mo-group-content">
          <Checkbox class="mo-group-check" value={this.isMapOverlay} onClick={this.attachToMapOverlays}>
            Afficher les cartes du groupe en surcouche
          </Checkbox>
          <div class="mo-group-list">
            <h2 class="mo-group-list-title">Liste des cartes attachées</h2>
            <div class="mo-group-list-scroller">{this.renderMapsList()}</div>
          </div>
          <button class="button is-small" onClick={this.loadMapPicker}>Attacher des cartes</button>
        </div>
      </div>
    );
  }
}

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-78aaa32c/map-overlays.tsx" });